import { apiClient } from '../lib/api';
import type { Order, ClientUnpaidOrdersResponse, ClientAcceptedOrdersResponse, UnpaidOrdersResponse } from '../types';

// Define inputs for creation if not strictly typed yet in index.ts
// Usually keeping 'any' or defining a specific CreateOrderDTO is good practice.
// For now, aligning with the usage in OrderConfirmationPage.tsx
export type CreateOrderPayload = any;

export const orderService = {
    getOrders: async (): Promise<Order[]> => {
        return apiClient.request<Order[]>('/orders/');
    },

    createOrder: async (order: CreateOrderPayload): Promise<Order> => {
        return apiClient.request<Order>('/orders/', {
            method: 'POST',
            body: JSON.stringify(order),
        });
    },

    createBatchOrders: async (orders: CreateOrderPayload[]): Promise<{ orders_queued: number; order_numbers?: number[] }> => {
        return apiClient.request<{ orders_queued: number; order_numbers?: number[] }>('/orders/batch/', {
            method: 'POST',
            body: JSON.stringify({ orders }),
        });
    },

    getClientUnpaidOrders: async (): Promise<ClientUnpaidOrdersResponse> => {
        return apiClient.request<ClientUnpaidOrdersResponse>('/orders/client-unpaid-orders');
    },

    getClientAcceptedOrders: async (): Promise<ClientAcceptedOrdersResponse> => {
        return apiClient.request<ClientAcceptedOrdersResponse>('/orders/client-accepted-orders');
    },

    getTableUnpaidOrders: async (tableId: string): Promise<UnpaidOrdersResponse> => {
        return apiClient.request<UnpaidOrdersResponse>(`/tables/${tableId}/unpaid-orders/`);
    },
};
